<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
        <v-card>
            <v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col class="" cols="6">
                            <v-text-field dense label="Nome" outlined v-model="pessoa.nome"></v-text-field>
                        </v-col>
                        <v-col class="" cols="6">
                            <v-text-field dense label="Email" outlined v-model="pessoa.email"></v-text-field>
                        </v-col>
                        <v-col class="" cols="6">
                            <v-select dense :items="this.listaSexo" v-model="pessoa.sexo" label="Sexo" outlined></v-select>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field dense label="Telefone" v-model="pessoa.telefone" outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-menu ref="abrirDtNascimentoPicker" v-model="abrirDtNascimentoPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field dense label="Data de Nascimento" v-model="dataNascimentoFormatada" v-on="on" outlined></v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="dataNascimento" no-title @input="abrirDtNascimentoPicker = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field dense label="Signo" outlined v-model="pessoa.signo" readonly></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field dense label="Desafio" outlined v-model="pessoa.desafio" readonly></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field dense label="Mestre" outlined v-model="pessoa.mestre" readonly></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="mostrarResp">
                        <v-col cols="12">
                            <fieldset class="px-2 borda">
                                <legend class="px-1">Responsável</legend>
                                <v-container>
                                    <v-row>
                                        <v-col cols="2">
                                            <v-text-field dense outlined append-icon="mdi-magnify" readonly @click:append="showResponsavel" label="Código" v-model="pessoa.responsavel.id"></v-text-field>
                                            <v-menu v-model="buscandoResponsavel"
                                                    
                                                    :position-x="x"
                                                    :position-y="y"
                                                    absolute
                                                    offset-x
                                                    :close-on-content-click="closeOnClick"
                                                    min-width="300"
                                                    >
                                                <v-card>
                                                    <v-container>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <v-text-field outlined dense label="Pesquisar por" v-model="nomePesquisa"></v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <v-data-table locale="pt-BR" dense fixed-header class="table-item" :items="pessoas" :headers="fields" :items-per-page="15">
                                                                    <template v-slot:item.action="{ item }">
                                                                        <v-btn icon class="mx-1" color="primary" @click="selecionar(item)">
                                                                            <v-icon>mdi-check</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                </v-data-table>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>
                                                </v-card>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="8">
                                            <v-text-field outlined dense readonly label="Nome" v-model="pessoa.responsavel.nome"></v-text-field>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-text-field outlined dense label="Parentesco" v-model="pessoa.responsavel.parentesco"></v-text-field>
                                        </v-col>
                                        <v-col cols="8">
                                            <v-text-field outlined dense readonly label="Email" v-model="pessoa.responsavel.email"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field outlined dense readonly label="Telefone" v-model="pessoa.responsavel.telefone"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </fieldset>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios'
import { baseApiUrl, showSuccess, showError } from "@/config/global"
import metodos from '@/mixins/metodos.js'

export default{
    
    props:['mostrar'],
    mixins:[metodos],
    data(){
        return{
            closeOnClick: false,
            buscandoResponsavel: false,
            abrirDtNascimentoPicker: false,
            cor: 'primary',
            dataNascimento: '',
            dataNascimentoFormatada: '',
            listaSexo: [
					{value: 'M', text: 'Masculino'},
					{value: 'F', text: 'Feminino'}
                ],
            pessoa: {
                responsavel:{

                }
            },
            pessoas: [],
            nomePesquisa: '',
            x: 0,
            y: 0,
            fields: [
					{value: 'id_user', text: 'Código', align: 'center'},
					{value: 'nome', text: 'Nome', align: 'center'},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
                ],
            mostrarResp: false
            
        }
    },

    methods:{
            
            salvar(){
                const url = `${baseApiUrl}/Atendimentos/Pessoas/insert.php`
                this.pessoa.data_nascimento = this.pessoa.dataNascimentoObj.toLocaleDateString('pt-Br')
						
                axios.post(url, this.pessoa)
                    .then(res => {
                        
                        if(res.data.codigo == '01'){
                            this.pessoa.id = res.data.id
                            showSuccess(res.data.mensagem)
                            this.fechar()
                            this.$emit('pessoaCadastrada', this.pessoa)
                        }else if(res.data.codigo == '03'){
                            showError(res.data.mensagem)
                        }else{
                            showError(res.data.mensagem)
    
                        }              
                })
            },

            selecionar(responsavel){
                this.pessoa.responsavel = responsavel
                this.buscandoResponsavel = false
                this.responsavel = {}
            },

            buscaResponsavel(n){
            
                const url = `${baseApiUrl}/Atendimentos/Pessoas/pesquisa.php?nome=${n}`

                axios.post(url, n).then(res => {
                    
                    this.pessoas = res.data
                })
            },

            fechar(){
                this.$emit('fecharNovaPessoa')
            },

            showResponsavel(e) {
                this.iniciados = [],
                this.nomePesquisa = '',
                this.x = e.clientX
                this.y = e.clientY        
                this.buscandoResponsavel = true    
            },

            mostraResponsavel(v){
                let dtNascimento = new Date(v)
                this.mostrarResp = new Date().getFullYear() - dtNascimento.getFullYear() < 18 ? true : false
            }
    },

    watch:{
        dataNascimento(){
				this.dataNascimentoFormatada = this.formataDateBr(this.dataNascimento)
                this.pessoa.dataNascimentoObj = this.converterData(this.dataNascimento)
                this.pessoa.signo = this.retornaSigno(this.pessoa.dataNascimentoObj)
                this.pessoa.desafio = this.retornaDesafio(this.pessoa.dataNascimentoObj)
                this.pessoa.mestre = this.retornaMestre(this.pessoa.dataNascimentoObj)
                this.mostraResponsavel(this.pessoa.dataNascimentoObj)
        },

        mostrar(val){
            if(val){
                this.pessoa = {
                    responsavel : {

                    }
                }
            }
            
        },

        nomePesquisa(val){    
            this.buscaResponsavel(val)
        },
    },
}
</script>
<style scoped>
    .borda{
        border-radius: 6px;
        border-color: rgba(0,0,0,0.4);
        border-width: 1px;
    }
</style>